import React from 'react';
import { toast } from 'react-toastify';
import { Box, Typography } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import * as tus from 'tus-js-client';
import api from 'services/api';

const STATUS_ICON = {
  uploading: CloudUploadIcon,
  success: CheckCircleIcon,
  error: ErrorIcon,
};

const STATUS_COLOR = {
  uploading: '#757575',
  success: '#2DCE98',
  error: '#f44336',
};

function UploadToastBody({ title, status, progress }) {
  const Icon = STATUS_ICON[status];
  const isSuccess = status === 'success';
  const statusText = isSuccess
    ? 'Upload concluído'
    : status === 'error'
    ? 'Falha no upload'
    : `Enviando vídeo... ${progress}%`;

  return (
    <Box display="flex" alignItems="flex-start" style={{ gap: 8 }}>
      <Icon
        style={{ color: isSuccess ? '#fff' : STATUS_COLOR[status], marginTop: 2 }}
        fontSize="small"
      />
      <Box style={{ minWidth: 0 }}>
        <Typography
          variant="body2"
          style={{ fontWeight: 600, color: isSuccess ? '#fff' : undefined }}
          noWrap
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          style={isSuccess ? { color: '#fff' } : undefined}
          color={!isSuccess ? (status === 'error' ? 'error' : 'textSecondary') : undefined}
        >
          {statusText}
        </Typography>
      </Box>
    </Box>
  );
}

export function startVimeoUpload({ file, name, description, onProgress, onSuccess, onError }) {
  const title = name || file.name;

  const toastId = toast(<UploadToastBody title={title} status="uploading" progress={0} />, {
    autoClose: false,
    closeButton: false,
    closeOnClick: false,
    draggable: false,
    progress: 0,
  });

  (async () => {
    try {
      const { data } = await api.post('/vimeo/ticket', {
        name,
        description,
        size: file.size,
      });

      await new Promise((resolve, reject) => {
        const upload = new tus.Upload(file, {
          uploadUrl: data.uploadLink,
          retryDelays: [0, 3000, 5000, 10000, 20000],
          chunkSize: 100 * 1024 * 1024,
          metadata: { filename: file.name, filetype: file.type },
          onError: reject,
          onProgress: (bytesUploaded, bytesTotal) => {
            const progress = Math.round((bytesUploaded / bytesTotal) * 100);
            toast.update(toastId, {
              render: <UploadToastBody title={title} status="uploading" progress={progress} />,
              progress: Math.min(progress, 99) / 100,
            });
            if (onProgress) onProgress(progress);
          },
          onSuccess: resolve,
        });
        upload.start();
      });

      toast.update(toastId, {
        render: <UploadToastBody title={title} status="success" />,
        type: toast.TYPE.SUCCESS,
        progress: null,
        autoClose: 4000,
        closeButton: true,
        closeOnClick: true,
        draggable: true,
      });
      if (onSuccess) onSuccess(data.uri);
    } catch (err) {
      toast.update(toastId, {
        render: <UploadToastBody title={title} status="error" />,
        type: toast.TYPE.ERROR,
        progress: null,
        autoClose: 6000,
        closeButton: true,
        closeOnClick: true,
        draggable: true,
      });
      if (onError) onError(err);
    }
  })();

  return toastId;
}
